
document.addEventListener("DOMContentLoaded", function () {

const menuOpenButton = document.querySelector(".openmenu");
const menuCloseButton = document.querySelector(".menu-close-button");
const mobileMenuDropdown = document.querySelector(".mobile-menu-dropdown");
const darkOverlay = document.querySelector(".dark_overlay");

// const topSearchButton = document.querySelector("#topSearchButton");
// const topSearchBar = document.querySelector("#topSearchBar");
// const searchbarCloseButton = document.querySelector(".searchbar-close-button");

const searchFormBlock = document.getElementById("search_form_block");


menuOpenButton.addEventListener("click", () => {
  document.body.classList.add("deactivatescroll");
  darkOverlay.classList.add("active");
  mobileMenuDropdown.classList.add("mobile-menu-dropdown--open");
});

menuCloseButton.addEventListener("click", () => {
  document.body.classList.remove("deactivatescroll");
   darkOverlay.classList.remove("active");
  mobileMenuDropdown.classList.remove("mobile-menu-dropdown--open");
});

  function closeMenu() {
    document.body.classList.remove("deactivatescroll");
    darkOverlay.classList.remove("active");
    if (mobileMenuDropdown) {
      mobileMenuDropdown.classList.remove("mobile-menu-dropdown--open");
    }
  }

  ////////////////////////////////////////////////////
 // Event Listener for Menu-item's with Sub-menu's //
////////////////////////////////////////////////////

var menuItemWithChildren = document.querySelectorAll('.menu-item-has-children');
var mobileMenu = document.querySelector('.mobile-nav');
//var desktopMenu = document.querySelector('#desktopNav');


  // Function to remove 'childrenDisplay' from all subMenuWrapper elements
  function removeChildrenDisplay() {
      document.querySelectorAll('.subMenuWrapper').forEach(wrapper => {
          wrapper.classList.remove('childrenDisplay');
      });
  }

  // Function to check if the parent menu item has 'no-sub-wrap' class
  function hasNoSubWrap(parentItem) {
      return parentItem.classList.contains('show-child');
  }

  addEventListener("resize", (event) => { })

    onresize = (event) => {
        //setTimeout(() => {closeMenu(), 500});

        //setTimeout(() => {removeChildrenDisplay(), 500});

    }

    darkOverlay.addEventListener("click", () => {
        setTimeout(() => {closeMenu(), 500});

        setTimeout(() => {removeChildrenDisplay(), 500});
});

  // Function to process each .menu-item-has-children
  function processMenuItems(parentItem) {
      // Find the direct child .sub-menu inside the current .menu-item-has-children
      const subMenu = parentItem.querySelector('.sub-menu');

      // If a .sub-menu is found and its parent does not have the .no-sub-wrap class, wrap it
      if (subMenu && !hasNoSubWrap(parentItem)) {
          // Create a wrapper div for each submenu
          const subMenuWrapper = document.createElement('div');
          subMenuWrapper.classList.add('subMenuWrapper');

          // Move the .sub-menu inside the subMenuWrapper
          subMenuWrapper.appendChild(subMenu);

          // Create a button to toggle the submenu visibility
          const mobilebutton = document.createElement('button');
          mobilebutton.textContent = 'Back'; // Button text can be customized
          mobilebutton.classList.add("btn", "btn-back");
          // Append the button inside the subMenuWrapper
          subMenuWrapper.prepend(mobilebutton);

          // Append the subMenuWrapper inside the parentItem
          parentItem.appendChild(subMenuWrapper);

          // Add event listener for toggling submenus
          parentItem.addEventListener('click', function (event) {
              event.stopPropagation(); // Prevent event bubbling

              // Add 'childrenDisplay' to the clicked submenu wrapper
              subMenuWrapper.classList.add('childrenDisplay');
          });

          // Button toggle to hide the submenu
          mobilebutton.addEventListener('click', function (event) {
              event.stopPropagation(); // Prevent event bubbling

              // Toggle 'childrenDisplay' on the submenu
              subMenuWrapper.classList.remove('childrenDisplay');
          });
      }

      // Recursively process all nested .menu-item-has-children elements inside the current submenu
      const nestedItems = parentItem.querySelectorAll(':scope > .sub-menu > .menu-item-has-children');
      nestedItems.forEach(function (nestedItem) {
          processMenuItems(nestedItem);
      });
  }

   // Check if .mobile-nav exists before running the function
   const mobileNav = document.querySelector('.mobile-nav');
   if (mobileNav) {
       // Get all top-level elements with class .menu-item-has-children inside .mobile-nav
       const parentItems = mobileNav.querySelectorAll('.menu-item-has-children');

       // Loop through each parent item and process it
       parentItems.forEach(function (parentItem) {
           processMenuItems(parentItem);
       });
   }

});
